import { useSelector } from 'react-redux';
import { getPlanContext } from '../../authSlice/authSelectors';

export function useGetPlanContext(): string {
  const planContext = useSelector(getPlanContext);
  return planContext;
}
